module.exports = __webpack_public_path__ + "media/images/gallery/constellations/border_layer_on-fa3dfb16138d27cf8d9dfe72e3f9aea4.jpg";